export function formatRating(value) {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return "—";
  return num.toFixed(1);
}

export function ratingLabel(average) {
  const value = Number(average);
  if (!Number.isFinite(value) || value <= 0) return "Not yet rated";
  if (value >= 4.5) return "Excellent";
  if (value >= 3.5) return "Good";
  if (value >= 2.5) return "Fair";
  return "Needs improvement";
}

export function sortContractors(list, sortBy) {
  const rows = [...list];
  if (sortBy === "rating") {
    return rows.sort((a, b) => {
      const diff = (Number(b.averageRating) || 0) - (Number(a.averageRating) || 0);
      if (diff !== 0) return diff;
      return (Number(b.ratingCount) || 0) - (Number(a.ratingCount) || 0);
    });
  }
  if (sortBy === "reviews") {
    return rows.sort((a, b) => (Number(b.ratingCount) || 0) - (Number(a.ratingCount) || 0));
  }
  return rows.sort((a, b) => String(a.businessName || "").localeCompare(String(b.businessName || "")));
}